import { yup } from 'common/validation/initYup';
import { ValidationSchema } from 'common/validation/ValidationSchema';
import { Type, Transform, plainToClass, classToPlain } from 'class-transformer';
import { TypeTransformDecimal } from 'common/dto/shared/types/TypeTransformDecimal';
import { Decimal } from 'decimal.js-light';
import { ApiProperty } from '@nestjs/swagger';
import type { IDto, IDtoPartial } from 'common/dto/shared/DtoInterfaces';
import { GenerateDto } from "cli/generate/decorators/GenerateDecorators";
import { RoleName } from 'common/permissions/Roles';

@GenerateDto()
class UserAuthoritiesSelect {
  role!: RoleName;
}

/**
 * Rappresentazione DTO della classe UserAuthoritiesSelect 
 * Hash: 433a4c2f4f06c704300012ae47be8175
 */
@ValidationSchema(() => UserAuthoritiesSelectSchema)
export class UserAuthoritiesSelectDto {
  @ApiProperty({ })
  role!: "SuperAdmin" | "DocumentalUser" | "GenericUser" | "Compiler" | "QualitySecretary" | "QualityManager" | "RiskManager" | "Approver" | "StrategicDirector";

  /** Proprietà che identifica i DTO */
  readonly __dto!: any;

  /**
   * Crea una nuova istanza con i valori forniti
   */
  constructor(values?: IDtoPartial<UserAuthoritiesSelectDto>) {
    if (values != null) {
      Object.assign(this, values instanceof UserAuthoritiesSelectDto ? values : plainToClass(UserAuthoritiesSelectDto, values));
    }
  }

  async validate(options?: any) {
    const validated = await UserAuthoritiesSelectSchema.validate(classToPlain(this), options);
    return new UserAuthoritiesSelectDto(validated);
  }
}

export const UserAuthoritiesSelectSchema = yup
  .object({
    role: yup.mixed().required()
  })
  .noUnknown()
  .meta({ schemaName: "UserAuthoritiesSelectSchema" })
  .required();
